import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import SelectAsync from 'react-select/async';

export default class TimeSheetsMy extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'timesheet',
            data: null,
            loading: true,
            time_sheet_header_id: this.getDefaultGuid(),
            timeSheets: [],
            timeSheetTotal: 0,
            timeSheetMamoriyatTotal: 0,
            timeSheetExtraTotal: 0,
            timeSheetReduceTotal: 0,
            timeSheetHeader: null,
            record: this.blankRecord(),
            menuId: 65
        };
    }
    blankRecord() {
        return {
            id: this.getDefaultGuid(),
            enterHour: 0,
            enterMinute: 0,
            exitHour: 0,
            exitMinute: 0,
            day: 0,
            description: '',
            timeMode: 1,
            mamoriyatTime: 0,
            productionLineId: this.getDefaultGuid(),
            productionLineName: '',
        }
    }
    save(e) {
        e.preventDefault();
        if (this.isBlank(this.state.record.enterHour)) this.state.record.enterHour = 0;
        if (this.isBlank(this.state.record.enterMinute)) this.state.record.enterMinute = 0;
        if (this.isBlank(this.state.record.exitHour)) this.state.record.exitHour = 0;
        if (this.isBlank(this.state.record.exitMinute)) this.state.record.exitMinute = 0;
        if (this.isBlank(this.state.record.mamoriyatTime)) this.state.record.mamoriyatTime = 0;
        if (this.isBlank(this.state.record.day)) this.state.record.day = 0;

        this.httpPost("api/v1/timesheet/save", {
           // companyId: this.state.data.global.company.id,
            timeSheetHeaderId: this.state.time_sheet_header_id,
            id: this.state.record.id,
            day: this.state.record.day,
            timeMode: this.state.record.timeMode,
            description: this.state.record.description,
            enterHour: parseInt(this.state.record.enterHour),
            enterMinute: parseInt(this.state.record.enterMinute),
            exitHour: parseInt(this.state.record.exitHour),
            exitMinute: parseInt(this.state.record.exitMinute),
            mamoriyatTime: parseInt(this.state.record.mamoriyatTime),
            productionLineId: this.state.record.productionLineId,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.record = this.blankRecord();
                    this.showSuccessMessage("اطلاعات با موفقیت ثبت شد");
                    this.getTimeSheets(this.state.time_sheet_header_id)
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    remove(id) {
        this.httpPost("api/v1/timesheet/remove", {
            id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.record = this.blankRecord();
                    this.showSuccessMessage("اطلاعات با موفقیت حذف شد");
                    this.getTimeSheets(this.state.time_sheet_header_id)
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    componentDidMount() {
        this.refreshData(null, "my");
    }
    showTimeSheets(e) {
        var time_sheet_header_id = e.target.value;
        if (time_sheet_header_id == this.getDefaultGuid()) {
            this.setState({
                time_sheet_header_id: this.getDefaultGuid(),
                timeSheets: [],
                timeSheetTotal: 0,
                timeSheetMamoriyatTotal: 0,
                timeSheetExtraTotal: 0,
                timeSheetReduceTotal: 0,
                timeSheetHeader: null,
            })
            return;
        }
        this.getTimeSheets(time_sheet_header_id);
    }
    getTimeSheets(time_sheet_header_id) {
        this.setState({ loading: true });

        this.httpPost("api/v1/" + this.state.controllerName + "/list", {
            time_sheet_header_id
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 0) {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
                else {
                    this.setState({
                        time_sheet_header_id,
                        timeSheets: data.records,
                        timeSheetTotal: data.timeSheetTotal,
                        timeSheetMamoriyatTotal: data.timeSheetMamoriyatTotal,
                        timeSheetExtraTotal: data.timeSheetExtraTotal,
                        timeSheetReduceTotal: data.timeSheetReduceTotal,
                        timeSheetHeader: data.timeSheetHeader,
                        loading: false
                    })
                }
            })
    }
    getHours() {
        var s = [];
        for (var i = 0; i <= 24; i++) s.push(i);
        return s;
    }
    getMinutes() {
        var s = [];
        for (var i = 0; i <= 60; i++) s.push(i);
        return s;
    }
    getMonthName(e) {
        if (e == 1) return "فروردین";
        if (e == 2) return "اردیبهشت";
        if (e == 3) return "خرداد";
        if (e == 4) return "تیر";
        if (e == 5) return "مرداد";
        if (e == 6) return "شهریور";
        if (e == 7) return "مهر";
        if (e == 8) return "آبان";
        if (e == 9) return "آذر";
        if (e == 10) return "دی";
        if (e == 11) return "بهمن";
        if (e == 12) return "اسفند";
        return "";
    }
    getDays() {
        var s = [];
        for (var i = 1; i <= 31; i++) s.push(i);
        return s;
    }
    getLineSeries() {
        var r = [];
        var r2 = [];
        var r3 = [];
        this.state.timeSheets.forEach(header => {
            var sum = 0;
            var sum2 = 0;
            var sum3 = 0;
            this.state.timeSheets.forEach(data => {
                if (data.dayNameString === header.dayNameString && data.day === header.day) {
                    sum += data.duration;
                    if (data.type == 1) sum2 += data.duration;
                    if (data.type == 2) sum3 += data.duration;
                }
            });
            r.push([header.dayNameString + " " + header.day + " " + this.getMonthName(this.state.timeSheetHeader.month), sum]);
            r2.push([header.dayNameString + " " + header.day + " " + this.getMonthName(this.state.timeSheetHeader.month), sum2]);
            r3.push([header.dayNameString + " " + header.day + " " + this.getMonthName(this.state.timeSheetHeader.month), sum3]);
        });
        return [
            {
                data: r,
                name: 'کارکرد کل',
                type: 'line'
            },
            {
                data: r2,
                name: 'کارکرد خود اظهاری',
                type: 'line'
            },
            {
                data: r3,
                name: 'کارکرد بر مبنای انجام وظایف',
                type: 'line'
            }
        ];
    }
    setProductionLine(e) {
        this.state.record.productionLineId = e.value;
        this.state.record.productionLineName = e.label;
        this.setState({ record: this.state.record });
    }
    renderForm() {
        if (!this.hasPermission(this.state.menuId)) return this.renderPermissionDenied();
        return <div>
            <div className="nk-content-body">
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="col-lg-12">
                            <div className="card h-100">
                                <div className="card-inner">
                                    <div className="row g-4">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <label className="form-label">تایم شیت کاری</label>
                                                <div className="form-control-wrap">
                                                    <select defaultValue={this.state.time_sheet_header_id} className="form-control" onChange={e => this.showTimeSheets(e)}>
                                                        <option value={this.getDefaultGuid()}>لطفا یکی از تایم شیتها را انتخاب نمایید</option>
                                                        {this.state.data.timeSheetHeaders.map(record =>[
                                                            record.type === 1 && <option value={ record.id } >
                                                            قرارداد شماره {record.contractNumber} شرکت {record.companyName} با موضوع {record.contractSubject} - {this.getMonthName(record.month)} {record.year}
                                                            </option>
                                                            ,
                                                            record.type === 2 && <option value={record.id} >
                                                                {record.solutionTitle} - {this.getMonthName(record.month)} {record.year}
                                                            </option>
                                                            ,
                                                            record.type === 3 && <option value={record.id} >
                                                                {record.crmTeamTitle} - {this.getMonthName(record.month)} {record.year}
                                                            </option>
                                                            ,
                                                            record.type === 4 && <option value={record.id} >
                                                                {record.orderingTitle} - {this.getMonthName(record.month)} {record.year}
                                                            </option>
                                                            
                                                        ])}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.state.time_sheet_header_id != this.getDefaultGuid() && <div className="card-inner-group">
                            {(this.state.timeSheetHeader.type === 1 || this.state.timeSheetHeader.type === 4) && <div className="card-inner">
                                <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                    <div className="col-lg-1">
                                        <div className="form-group">
                                            <label className="form-label">روز</label>
                                            <div className="form-control-wrap">
                                                <select className="form-control text-center" defaultValue={this.state.record.day} onChange={e => this.state.record.day = parseInt(e.target.value)}>
                                                    <option value="0">انتخاب</option>
                                                    {this.getDays().map(day => <option value={day}>{day}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">ساعت شروع</label>
                                            <div className="form-control-wrap">
                                                <select style={{ "width": "80px", "display": "inline" }} className="form-control text-center" defaultValue={this.state.record.enterMinute} onChange={e => this.state.record.enterMinute = parseInt(e.target.value)}>
                                                    {this.getMinutes().map(m =>
                                                        <option value={m}>{m}</option>
                                                    )}
                                                </select>
                                                :
                                                <select style={{ "width": "80px", "display": "inline" }} className="form-control text-center" defaultValue={this.state.record.enterHour} onChange={e => this.state.record.enterHour = parseInt(e.target.value)}>
                                                    {this.getHours().map(m =>
                                                        <option value={m}>{m}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">ساعت پایان</label>
                                            <div className="form-control-wrap">
                                                <select style={{ "width": "80px", "display": "inline" }} className="form-control text-center" defaultValue={this.state.record.exitMinute} onChange={e => this.state.record.exitMinute = parseInt(e.target.value)}>
                                                    {this.getMinutes().map(m =>
                                                        <option value={m}>{m}</option>
                                                    )}
                                                </select>
                                                :
                                                <select style={{ "width": "80px", "display": "inline" }} className="form-control text-center" defaultValue={this.state.record.exitHour} onChange={e => this.state.record.exitHour = parseInt(e.target.value)}>
                                                    {this.getHours().map(m =>
                                                        <option value={m}>{m}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.timeSheetHeader.type === 4 && <div className="col-lg-3">
                                        <div className="form-group">
                                            <label className="form-label">خط تولید</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    value={this.state.record.productionLineId != this.defaultGuid() ? [{ value: this.state.record.productionLineId, label: this.state.record.productionLineName }] : null}
                                                    isMulti={false}
                                                    placeholder="انتخاب خط تولید"
                                                    noOptionsMessage={({ inputValue }) =>
                                                        inputValue ? "نتیجه‌ای یافت نشد" : null
                                                    }
                                                    defaultOptions={[]}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                    }}
                                                    loadOptions={(inputValue, callback) => this.loadProductionLinesOptions(inputValue, callback, this.state.time_sheet_header_id)}
                                                    onChange={e => this.setProductionLine(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>}
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">زمان کارکرد</label>
                                            <div className="form-control-wrap">
                                                <select defaultValue={this.state.record.timeMode} className="form-control text-center" onChange={e => this.state.record.timeMode = parseInt(e.target.value)}>
                                                    <option value="1">روزکار</option>
                                                    <option value="2">شبکار</option>
                                                    <option value="3">نوبت کاری</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">ماموریت(دقیقه)</label>
                                            <div className="form-control-wrap">
                                                <input type="text" defaultValue={this.state.record.mamoriyatTime} className="form-control text-center" onChange={e => this.state.record.mamoriyatTime = parseInt(e.target.value)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">توضیحات کارکرد</label>
                                            <div className="form-control-wrap">
                                                <input type="text" className="form-control" defaultValue={this.state.record.description} onChange={e => this.state.record.description = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <button type="submit" className="btn btn-lg btn-primary">ثبت کارکرد</button>
                                        </div>
                                    </div>
                                </form>
                            </div>}
                            {(this.state.timeSheetHeader.type === 2 || this.state.timeSheetHeader.type === 3) && <div className="card-inner">
                                <form method="post" onSubmit={e => this.save(e)} className="row g-4">
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">روز</label>
                                            <div className="form-control-wrap">
                                                <select className="form-control text-center" defaultValue={this.state.record.day} onChange={e => this.state.record.day = parseInt(e.target.value)}>
                                                    <option value="0">انتخاب</option>
                                                    {this.getDays().map(day => <option value={day}>{day}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">ساعت شروع</label>
                                            <div className="form-control-wrap">
                                                <select style={{ "width": "80px", "display": "inline" }} className="form-control text-center" defaultValue={this.state.record.enterMinute} onChange={e => this.state.record.enterMinute = parseInt(e.target.value)}>
                                                    {this.getMinutes().map(m =>
                                                        <option value={m}>{m}</option>
                                                    )}
                                                </select>
                                                :
                                                <select style={{ "width": "80px", "display": "inline" }} className="form-control text-center" defaultValue={this.state.record.enterHour} onChange={e => this.state.record.enterHour = parseInt(e.target.value)}>
                                                    {this.getHours().map(m =>
                                                        <option value={m}>{m}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label className="form-label">ساعت پایان</label>
                                            <div className="form-control-wrap">
                                                <select style={{ "width": "80px", "display": "inline" }} className="form-control text-center" defaultValue={this.state.record.exitMinute} onChange={e => this.state.record.exitMinute = parseInt(e.target.value)}>
                                                    {this.getMinutes().map(m =>
                                                        <option value={m}>{m}</option>
                                                    )}
                                                </select>
                                                :
                                                <select style={{ "width": "80px", "display": "inline" }} className="form-control text-center" defaultValue={this.state.record.exitHour} onChange={e => this.state.record.exitHour = parseInt(e.target.value)}>
                                                    {this.getHours().map(m =>
                                                        <option value={m}>{m}</option>
                                                    )}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">توضیحات کارکرد</label>
                                            <div className="form-control-wrap">
                                                <input type="text" className="form-control" defaultValue={this.state.record.description} onChange={e => this.state.record.description = e.target.value} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <button type="submit" className="btn btn-lg btn-primary">ثبت کارکرد</button>
                                        </div>
                                    </div>
                                </form>
                            </div>}
                            {(this.state.timeSheetHeader.type === 1 || this.state.timeSheetHeader.type === 4) && <div className="card-inner p-0">
                                <div className="nk-tb-list nk-tb-ulist">
                                    <div className="nk-tb-item nk-tb-head">
                                        <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                        {this.state.timeSheetHeader.type === 4 && <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">خط تولید</span></div>}
                                        <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">روز ماه</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">عنوان روز</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">موظفی</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">ورود</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">خروج</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">کارکرد</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">زمان کارکرد</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">جمعه کاری</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">تعطیل کاری</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">ماموریت</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">اضافه کاری</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">کم کاری</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">توضیحات کارکرد</span></div>
                                        <div className="nk-tb-col text-end"><span className="sub-text">عملیات</span></div>
                                    </div>
                                    {this.state.timeSheets.map((record, index) =>
                                        <div className="nk-tb-item">
                                            <div className="nk-tb-col">
                                                <span className="sub-text">{(index + 1)}</span>
                                            </div>
                                            {this.state.timeSheetHeader.type === 4 && <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.productionLineName}</span>
                                            </div>}
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.day}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.dayName}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{this.FixedPointNumber((record.moazzafTime / 60), 2)}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.enterHour}:{record.enterMinute}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.exitHour}:{record.exitMinute}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {this.displayMinuteAsTimeFormat(record.duration)}
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {record.timeMode === 1 && <span class="tb-status text-info">روزکار</span>}
                                                {record.timeMode === 2 && <span class="tb-status text-warning">شبکار</span>}
                                                {record.timeMode === 3 && <span class="tb-status text-success">نوبتکاری</span>}
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {record.fridayTime == 0 && <span class="tb-status text-danger">خیر</span>}
                                                {record.fridayTime != 0 && <span class="tb-status text-success">بله</span>}
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {record.holidayTime == 0 && <span class="tb-status text-danger">خیر</span>}
                                                {record.holidayTime != 0 && <span class="tb-status text-success">بله</span>}
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {this.displayMinuteAsTimeFormat(record.mamoriyatTime)}
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {this.displayMinuteAsTimeFormat(record.extraTime)}
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {this.displayMinuteAsTimeFormat(record.reduceTime)}
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.description}</span>
                                            </div>
                                            <div className="nk-tb-col nk-tb-col-tools">
                                                <ul className="nk-tb-actions gx-1">
                                                    <li className="nk-tb-action-hidden">
                                                        <a className="btn btn-trigger btn-icon hand" onClick={e => this.confirmRemove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف رکورد">
                                                            <em className="icon ni ni-cross-fill-c"></em>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    )}
                                    <div className="nk-tb-item">
                                        <div className="nk-tb-col">
                                            <span className="sub-text">جمع کل</span>
                                        </div>
                                        {this.state.timeSheetHeader.type === 4 && <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>}
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md text-center">
                                            {this.displayMinuteAsTimeFormat(this.state.timeSheetTotal)}
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md text-center">
                                            {this.displayMinuteAsTimeFormat(this.state.timeSheetMamoriyatTotal)}
                                        </div>
                                        <div className="nk-tb-col tb-col-md text-center">
                                            {this.displayMinuteAsTimeFormat(this.state.timeSheetExtraTotal)}
                                        </div>
                                        <div className="nk-tb-col tb-col-md text-center">
                                            {this.displayMinuteAsTimeFormat(this.state.timeSheetReduceTotal)}
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>}
                            {(this.state.timeSheetHeader.type === 2 || this.state.timeSheetHeader.type === 3 ) && <div className="card-inner p-0">
                                <h4 className="mt-4 text-center">گزارش کارکرد {this.getMonthName(this.state.timeSheetHeader.month)} ماه</h4>
                                <div className="nk-tb-list nk-tb-ulist">
                                    <div className="nk-tb-item nk-tb-head">
                                        <div className="nk-tb-col"><span className="sub-text">ردیف</span></div>
                                        <div className="nk-tb-col tb-col-sm"><span className="sub-text text-center">روز</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">عنوان روز</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">زمان کارکرد</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">شرح وظیفه</span></div>
                                        <div className="nk-tb-col tb-col-md"><span className="sub-text text-center">شرح اقدامات انجام یافته</span></div>
                                        {this.state.timeSheetHeader.type === 2 && <div className="nk-tb-col tb-col-md"><span className="sub-text text-center"></span></div>}
                                    </div>
                                    {this.state.timeSheets.map((record, index) =>
                                        <div className="nk-tb-item">
                                            <div className="nk-tb-col">
                                                <span className="sub-text">{(index + 1)}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.day}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.dayNameString}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md text-center">
                                                {this.displayMinuteAsTimeFormat(record.duration)}
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.description}</span>
                                            </div>
                                            <div className="nk-tb-col tb-col-md">
                                                <span className="sub-text text-center">{record.note}</span>
                                            </div>
                                            {this.state.timeSheetHeader.type === 2 &&
                                                <div className="nk-tb-col tb-col-md">
                                                    <span className="sub-text text-center">
                                                        <a className="item-delete-btn" onClick={e => this.remove(record.id)} data-bs-toggle="modal" data-bs-target="#modalConfirmRemove" title="حذف">
                                                            <i className="mir-trash text-danger"></i>
                                                        </a>
                                                    </span>
                                                </div>}
                                        </div>
                                    )}
                                    <div className="nk-tb-item">
                                        <div className="nk-tb-col">
                                            <span className="sub-text">جمع کل</span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md text-center">
                                            {this.displayMinuteAsTimeFormat(this.state.timeSheetTotal)}
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                        <div className="nk-tb-col tb-col-md">
                                            <span className="sub-text text-center"></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="mt-4">
                                    <HighchartsReact
                                        highcharts={Highcharts}
                                        options={{
                                            title: {
                                                text: 'روند کارکرد به تفکیک روزهای ماه'
                                            },
                                            series: this.getLineSeries(),
                                            xAxis: {
                                                title: {
                                                    text: 'روزهای ماه'
                                                },
                                                type: 'category',
                                            },
                                            yAxis: {
                                                title: {
                                                    text: 'کارکرد به دقیقه'
                                                },
                                            },
                                        }
                                        }
                                     />
                                </div>
                            </div>}
                        </div>}
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}